import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeOuiNon } from '../models/TypeOuiNon';
@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'TypeOuiNon';
  @Input() parentForm: FormGroup;
  @Input() variantes: TypeOuiNon;
  @Input() disabled: boolean;
  

  radioButtonValue;
  radioButtonCtrlName;
  oui = 'oui';
  non = 'non';

  constructor() {}

  public ngOnInit() {
    if (this.variantes.non) {
      this.radioButtonValue = this.non;
    } else if (this.variantes.oui) {
      this.radioButtonValue = this.oui;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_oui';
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
